import React, { useContext, useEffect, useState } from 'react';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';

// Components
import BoardTemplatePickerCopyLoader from './loader/BoardTemplatePickerCopyLoader';
import BoardTemplatePickerPublicParentPopup from './publicTemplatePopup/BoardTemplatePickerPublicParentPopup';
import DesktopBoardTemplatePickerPopupContent from './DesktopBoardTemplatePickerPopupContent';

// Context
import { boardTemplatePickerContext, BoardTemplatePickerContextProvider } from './context/boardTemplatePickerContext';

// Hooks
import { useCmsTemplateFetching } from './hooks/useCmsTemplateFetching';
import useShouldRenderTemplatePicker from './hooks/useShouldRenderTemplatePicker';

// Utils
import { isTemplatePublicParentBoard } from '../../../common/templates/templateUtil';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';

// Constants
import { ImMNElement } from '../../../common/elements/elementModelTypes';

// Styles
import './DesktopBoardTemplatePickerPopup.scss';
import './board-template-picker-content.scss';

type Props = {
    currentBoardId: string;
    currentBoard: ImMNElement;
};

const DesktopBoardTemplatePickerPopup = ({ currentBoardId, currentBoard }: Props) => {
    const { isCopyingTemplate, templatePickerVisible } = useContext(boardTemplatePickerContext);

    const [popupDismissed, setPopupDismissed] = useState(false);

    useEffect(() => {
        setPopupDismissed(false);
    }, [currentBoardId]);

    // shown to admins to make the board id to add to Prismic obvious
    if (isTemplatePublicParentBoard(currentBoard)) {
        return (
            <BoardTemplatePickerPublicParentPopup
                className="DesktopBoardTemplatePickerPopup"
                currentBoard={currentBoard}
            />
        );
    }

    const showPicker = templatePickerVisible && !isCopyingTemplate && !popupDismissed;

    return (
        <>
            {isCopyingTemplate && <BoardTemplatePickerCopyLoader />}

            <div className="DesktopBoardTemplatePickerPopup">
                <CSSTransitionGroup
                    transitionName="fade"
                    transitionAppear
                    transitionAppearTimeout={200}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    {showPicker && (
                        <DesktopBoardTemplatePickerPopupContent
                            currentBoard={currentBoard}
                            setPopupDismissed={setPopupDismissed}
                        />
                    )}
                </CSSTransitionGroup>
            </div>
        </>
    );
};
const DesktopBoardTemplatePickerPopupContainer = (props: Props) => {
    const currentBoardId = getElementId(props.currentBoard);

    useCmsTemplateFetching();

    const shouldRenderTemplatePicker = useShouldRenderTemplatePicker(currentBoardId);
    if (!shouldRenderTemplatePicker) return null;

    return (
        <BoardTemplatePickerContextProvider key={currentBoardId}>
            <DesktopBoardTemplatePickerPopup {...props} />
        </BoardTemplatePickerContextProvider>
    );
};

export default DesktopBoardTemplatePickerPopupContainer;
